"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _Services = require("../common_features/utility/Services");
var _OwnerDashBoardComponent = _interopRequireDefault(require("../components/OwnerDashBoardComponent"));
var _strings = require("../common_features/utility/strings");
var _reactRedux = require("react-redux");
var _storesReducer = require("../common_features/redux/reducers/storesReducer");
var _RoutePath = _interopRequireDefault(require("../RoutePath"));
var _helper = require("../common_features/utility/helper");
var _alertReducer = require("../common_features/redux/reducers/alertReducer");
var _index = _interopRequireDefault(require("../common_features/assets/images/index"));
var _event = require("../common_features/utility/event");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const OwnerDashBoard = () => {
  const [pageValue, setPageValue] = (0, _react.useState)(1);
  const [isLoading, setIsLoading] = (0, _react.useState)(true);
  const {
    userInfo
  } = (0, _reactRedux.useSelector)(state => state.login);
  let userType = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userType) === 6 ? true : false;
  let navigate = (0, _reactRouterDom.useNavigate)();
  const dispatch = (0, _reactRedux.useDispatch)();
  const [storesCount, setStoresCount] = (0, _react.useState)(0);
  const [storesList, setStoresList] = (0, _react.useState)([]);
  const listInnerRef = (0, _react.useRef)();
  const [scrollPosition, setScrollPosition] = (0, _react.useState)();
  const handleCreateStore = () => {
    navigate(_RoutePath.default.createStore.useLink);
  };
  const handleStoreClick = store => {
    dispatch((0, _storesReducer.selectStore)({
      ...store
    }));
    (0, _Services.getAlerts)(store.storeId).then(res => {
      if (res.success) {
        const payload = {
          storeId: store.storeId,
          data: res.data
        };
        dispatch((0, _alertReducer.alertData)(payload));
      }
    });
    navigate(_RoutePath.default.storeDashboard.useLink);
  };
  const structureAddress = str => {
    return (0, _helper.isJSON)(str) ? (0, _helper.bindAddress)(JSON.parse(str)) : str;
  };
  const getStoresList = async pValue => {
    var _storeList$data, _storeList$data$rows, _storeList$data2, _storeList$data3;
    const storeList = await (0, _Services.getStores)(pValue);
    return {
      stores: storeList !== null && storeList !== void 0 && (_storeList$data = storeList.data) !== null && _storeList$data !== void 0 && (_storeList$data$rows = _storeList$data.rows) !== null && _storeList$data$rows !== void 0 && _storeList$data$rows.length ? storeList === null || storeList === void 0 ? void 0 : (_storeList$data2 = storeList.data) === null || _storeList$data2 === void 0 ? void 0 : _storeList$data2.rows : [],
      count: storeList === null || storeList === void 0 ? void 0 : (_storeList$data3 = storeList.data) === null || _storeList$data3 === void 0 ? void 0 : _storeList$data3.count
    };
  };
  const getPageCountUpdated = async () => {
    dispatch((0, _storesReducer.storesLoading)());
    if (pageValue === 1) {
      dispatch((0, _storesReducer.clearStore)());
    }
    try {
      const alerts = await (0, _Services.GetNotifications)();
      dispatch((0, _alertReducer.generalAlertData)(alerts.data.rows));
    } catch (error) {}
    UpdatedStores(pageValue);
  };
  (0, _react.useEffect)(() => {
    dispatch((0, _storesReducer.storesInfo)([]));
    const customCall = async () => {
      const storesListAPI = await getStoresList(pageValue);
      setStoresCount(storesListAPI.count);
      sortStoresListBasedOnAlarm(storesListAPI);
      setIsLoading(false);
    };
    _event.eventEmitter.subscribe('socketOnMessage', data => {
      var _data$alert, _data$alert2, _data$alert3, _data$alert4;
      if ((data === null || data === void 0 ? void 0 : (_data$alert = data.alert) === null || _data$alert === void 0 ? void 0 : _data$alert.alarmCode) === 'GEN_STORE_DISABLED' || (data === null || data === void 0 ? void 0 : (_data$alert2 = data.alert) === null || _data$alert2 === void 0 ? void 0 : _data$alert2.alarmCode) === 'GEN_STORE_DELETED' || (data === null || data === void 0 ? void 0 : (_data$alert3 = data.alert) === null || _data$alert3 === void 0 ? void 0 : _data$alert3.alarmCode) === 'GEN_TAG_MANAGER_TO_STORE' || (data === null || data === void 0 ? void 0 : (_data$alert4 = data.alert) === null || _data$alert4 === void 0 ? void 0 : _data$alert4.alarmCode) === 'GEN_REMOVE_MANAGER_FROM_STORE') {
        customCall();
      }
    });
    customCall();
  }, []);
  (0, _react.useEffect)(() => {
    getPageCountUpdated();
  }, [pageValue]);
  const sortStoresListBasedOnAlarm = data => {
    var _data$stores, _data$stores2;
    let newdatawithAlarm = data === null || data === void 0 ? void 0 : (_data$stores = data.stores) === null || _data$stores === void 0 ? void 0 : _data$stores.filter(item => item.AlarmCount).map(store => {
      var _store$AlarmCount;
      if (store !== null && store !== void 0 && (_store$AlarmCount = store.AlarmCount) !== null && _store$AlarmCount !== void 0 && _store$AlarmCount.length) {
        store.AlarmCount.forEach(row => {
          if (row.severity === 1) {
            store.error = row.count;
          } else if (row.severity === 3) {
            store.optimize = row.count;
          } else if (row.severity === 2) {
            store.error = row.count;
          }
        });
      }
      return store;
    });
    let newdatawithOutAlarm1 = data === null || data === void 0 ? void 0 : (_data$stores2 = data.stores) === null || _data$stores2 === void 0 ? void 0 : _data$stores2.filter(item => !item.AlarmCount);
    let newdata = newdatawithAlarm;
    setStoresList([...storesList, ...newdata, ...newdatawithOutAlarm1]);
  };
  const UpdatedStores = pgValue => {
    getStoresList(pgValue).then(data => {
      sortStoresListBasedOnAlarm(data);
      /**
       * Scroll Position is set to previous scroll position where user was when another set of
       * paginated data is loaded from the API. Because the Spinner loaded re-initaites the scroll positions.
       */
      if (listInnerRef.current) {
        listInnerRef.current.scrollTop = scrollPosition;
      }
    });
  };
  const onScrollHandler = async e => {
    if (listInnerRef.current) {
      const {
        scrollTop,
        scrollHeight,
        clientHeight
      } = listInnerRef.current;
      setScrollPosition(scrollTop);
      if (scrollTop + clientHeight === scrollHeight && pageValue - 1 < Math.floor(storesList.length / 25)) {
        setPageValue(pageValue + 1);
      }
    }
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_OwnerDashBoardComponent.default, {
    heading: 'HOME DASHBOARD',
    subHeading: 'ServiceConnect',
    separator: '|',
    handleClick: handleStoreClick,
    stores: storesList === null || storesList === void 0 ? void 0 : storesList.map(store => ({
      ...store,
      address: structureAddress(store === null || store === void 0 ? void 0 : store.address)
    })),
    ownerMobileString: _strings.ownerMobileFirstVisitComponentString,
    isLoading: isLoading,
    loginType: 'owner',
    title: 'Total Stores',
    rightText: Number(storesCount),
    handleCreateStore: handleCreateStore,
    userType: userType,
    headerText: 'Welcome to your Home Dashboard!',
    string: _strings.dispatcherStoreDashboardString,
    isDisableIcon: _index.default.subscriptionExpireIcon.default,
    isDisableText: 'Subscription Expired',
    arrowIcon: _index.default.ArrowRight.default,
    onScrollHandler: onScrollHandler,
    listInnerRef: listInnerRef
  }));
};
var _default = exports.default = OwnerDashBoard;